module.exports = __webpack_public_path__ + "img/placeholder1.5d14dc05.jpg";